import React, { Component } from "react";
import { userActions } from "../acciones/userActions";
import { connect } from "react-redux";
import { DataTable } from "primereact/components/datatable/DataTable";
import { TabView, TabPanel } from "primereact/components/tabview/TabView";
import { withRouter } from "react-router-dom";
import Layout from "react-comun-seps/lib/components/Layout";
import {InputText} from "primereact/components/inputtext/InputText";

let I18n = require("react-redux-i18n").I18n;

class OrganizacionesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            globalFilter: null,
        };
        this.onClickOrganizacion = this.onClickOrganizacion.bind(this);
    }

    onClickOrganizacion(e, org) {
        const { dispatch } = this.props;
        dispatch(userActions.seleccionaOrganizacion(org));
    }

    componentDidMount() {
        this.updateOrganizaciones();
    }

    updateOrganizaciones() {
        const { dispatch } = this.props;
        dispatch(userActions.getOrganizaciones());
    }

    renderHeader = (
      <div style={{ textAlign: "right" }}>
          <i className="pi pi-search" style={{ margin: "10px 10px 0 0" }}></i>
          <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Buscar..." />
      </div>
    );

    mostrarorganizaciones(orgDataTable) {
        let tabeps;
        if (orgDataTable.organizacionSfps.length > 0) {
            tabeps = (
              <TabPanel header="SFPS">
                  <div>
                      <DataTable
                        header={this.renderHeader}
                        globalFilter={this.state.globalFilter}
                        value={orgDataTable.organizacionSfps}
                        selectionMode="single"
                        paginator={true}
                        rows={10}
                        
                        onSelectionChange={(e) => this.onClickOrganizacion(e, e.data)}
                      >
                          <column field="numRuc" header={I18n.t("app.ruc")} sortable={true}  />
                          <column field="nomRazonSocial" header={I18n.t("app.razon_social")} sortable={true}  />
                      </DataTable>
                  </div>
              </TabPanel>
            );
        }
        if (orgDataTable.organizacionEps.length > 0) {
            tabeps = (
              <TabPanel header="EPS">
                  <div>
                      <DataTable
                        header={this.renderHeader}
                        globalFilter={this.state.globalFilter}
                        value={orgDataTable.organizacionEps}
                        selectionMode="single"
                        paginator={true}
                        rows={10}
                        onSelectionChange={(e) => this.onClickOrganizacion(e, e.data)}
                        responsive={true}
                        ref={(el) => {
                            this.dt = el;
                        }}
                      >
                          <column field="numRuc" header={I18n.t("app.ruc")} sortable={true}/>
                          <column field="nomRazonSocial" header={I18n.t("app.razon_social")} sortable={true}/>
                      </DataTable>
                  </div>
              </TabPanel>
            );
        }
        return (
          <div>
              <TabView>{tabeps}</TabView>
          </div>
        );
    }

    render() {
        const { organizaciones } = this.props;
        if (organizaciones && organizaciones === "vacio") {
            this.onClickOrganizacion(null, null);
        }
        return (
          <div>
              {organizaciones && (
                <Layout
                  staticMenuDesktopInactive={true}
                  activarMenuPrincipal={false}
                  body={
                      <div className="ui-g dashboard">
                          <div className="ui-g-12">
                              <div className="card card-w-title">
                                  <h1>{I18n.t("app.organizaciones_asignadas")}</h1>
                                  {this.mostrarorganizaciones(organizaciones)}
                              </div>
                          </div>
                      </div>
                  }
                />
              )}
              {!organizaciones && (
                <div className="splash-screen">
                    <div className="splash-loader"></div>
                </div>
              )}
          </div>
        );
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
    const { user, sistema, organizaciones } = authentication;
    return {
        user,
        sistema,
        organizaciones,
    };
}

const connectedOrganizacionesContainer = withRouter(connect(mapStateToProps)(OrganizacionesContainer));
export { connectedOrganizacionesContainer as OrganizacionesContainer };